var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96265 1.3252V5.98877C1.96265 6.72162 2.56225 7.32122 3.2951 7.32122H5.96C6.31338 7.32122 6.6523 7.18084 6.90218 6.93095C7.15206 6.68107 7.29245 6.34216 7.29245 5.98877V1.3252",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62744 1.3252V14.6497",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9547 9.98612V1.3252C13.0712 1.3252 12.2239 1.67615 11.5992 2.30086C10.9745 2.92557 10.6235 3.77285 10.6235 4.65632V8.65367C10.6235 9.38652 11.2231 9.98612 11.956 9.98612H13.9547ZM13.9547 9.98612V14.6497",
    stroke: "#99A1AF",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_6643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.41685726c1e0036e679f8cf6da6163d5.svg";
export { ForwardRef as ReactComponent };